import { ActionIcon, Tooltip } from '@mantine/core';
import type { AttemptError, QualityCheckStatus, RunStatus } from '@prisma/client';
import { IconTool } from '@tabler/icons-react';
import { capFirst } from '~/common/string/capitalize';
import type { FailedAssertion } from '~/types';

export default function ResultSummary({
  executionError,
  failedAssertions,
  status,
  qualityCheckStatus,
}: {
  executionError?: AttemptError;
  failedAssertions: FailedAssertion[];
  status: RunStatus;
  qualityCheckStatus?: QualityCheckStatus | null;
}) {
  const isRunning = status === 'RUNNING' || status === 'RETRYING' || status === 'QUEUED';
  return (
    <div className="flex flex-col">
      <div className="flex flex-row gap-2">
        <span className="first-letter:capitalize">
          {qualityCheckStatus === 'PENDING' ?
            <span>Quality Check Running</span>
          : isRunning ?
            <span>{capFirst(status.toLowerCase())}</span>
          : executionError?.message?.includes('Timed out') ?
            <div className="flex flex-row items-center gap-1">
              <span>{executionError.message}</span>
              <Tooltip
                label="Increase the test timeout in the test suite settings."
                withArrow
              >
                <ActionIcon
                  variant="subtle"
                  size="xs"
                  radius="xl"
                >
                  <IconTool />
                </ActionIcon>
              </Tooltip>
            </div>
          : (executionError?.message ??
            (failedAssertions?.length ?
              <span>Failed assertion{failedAssertions?.length === 1 ? '' : 's'}</span>
            : <span>{capFirst(status.toLowerCase())}</span>))
          }
        </span>
      </div>
      {status === 'ERROR' && executionError?.stepTitle ?
        <span className="opacity-80">@ step &apos;{executionError.stepTitle}&apos;</span>
      : null}
    </div>
  );
}
